import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../utils/Enums';
import { apiClient } from '../../utils/ApiClient';
import OrderComponent from '../../models/OrderComponent';

interface OrderComponentsState {
    orderComponents: OrderComponent[];
    getOrderComponentsStatus: RequestStatus;
}

const initialState: OrderComponentsState = {
    orderComponents: [],
    getOrderComponentsStatus: RequestStatus.Idle,
};

export const getOrderComponents = createAsyncThunk(
    'orderComponents/getOrderComponents',
    async (_, { rejectWithValue }) => {
        const response = await apiClient.get('order-components');
        return response.data;
    }
);

const orderComponentsSlice = createSlice({
    name: 'orderComponents',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOrderComponents.pending, (state) => {
                state.getOrderComponentsStatus = RequestStatus.Loading;
            })
            .addCase(getOrderComponents.fulfilled, (state, action) => {
                state.getOrderComponentsStatus = RequestStatus.Success;
                state.orderComponents = action.payload;
            })
            .addCase(getOrderComponents.rejected, (state, action) => {
                state.getOrderComponentsStatus = RequestStatus.Failed;
            });
    },
});

export default orderComponentsSlice.reducer;